<template>
  <div>
    <h4 class="mb-1">Запросы на исправление</h4>
    <b-alert v-if="errorText" show variant="danger">{{ errorText }}</b-alert>
    <b-form-select v-model="status" class="w-25 mb-1" :options="statusOptions" @change="fetch" />
    <b-table :items="rows" :fields="fields" :busy="loading" striped responsive empty-text="Запросов нет">
      <template #cell(actions)="data">
        <b-button
          v-if="data.item.status === 'pending'"
          size="sm"
          variant="outline-success"
          class="mr-50"
          @click="resolve(data.item, true)"
        >
          Принять
        </b-button>
        <b-button
          v-if="data.item.status === 'pending'"
          size="sm"
          variant="outline-danger"
          @click="resolve(data.item, false)"
        >
          Отклонить
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import { BAlert, BButton, BFormSelect, BTable } from 'bootstrap-vue'
import identityApi from '@/services/identity-api.service'

export default {
  name: 'CorrectionsPage',
  components: { BAlert, BButton, BFormSelect, BTable },
  data() {
    return {
      loading: false,
      errorText: '',
      status: 'pending',
      statusOptions: [
        { value: 'pending', text: 'Ожидает' },
        { value: 'approved', text: 'Принято' },
        { value: 'rejected', text: 'Отклонено' },
        { value: '', text: 'Все' },
      ],
      rows: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'type', label: 'Тип' },
        { key: 'status', label: 'Статус' },
        { key: 'initiator', label: 'Инициатор', formatter: v => (v && `${v.surname || ''} ${v.name || ''}`.trim()) || '—' },
        { key: 'subject', label: 'Участник', formatter: v => (v && `${v.surname || ''} ${v.name || ''}`.trim()) || '—' },
        { key: 'start', label: 'Старт', formatter: v => (v && v.name) || '—' },
        { key: 'reason', label: 'Причина' },
        { key: 'actions', label: '' },
      ],
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      this.errorText = ''
      try {
        const { data } = await identityApi.getCorrections({ status: this.status || undefined, maxResultCount: 50 })
        this.rows = data.rows || []
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Не удалось загрузить запросы'
      } finally {
        this.loading = false
      }
    },
    async resolve(item, approve) {
      try {
        await identityApi.resolveCorrection(item.id, approve)
        this.fetch()
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Не удалось обработать'
      }
    },
  },
}
</script>
